import { useCallback, useMemo } from 'react'
import { History } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchAutomationAudit, AUTO_STR as S, type AutomationAuditRow } from './automationApi'

/**
 * A26.12 — Аудит автоматизации. Reads the REAL shared audit log
 * (`GET /admin/audit`) and keeps only the automation_* actions the automation
 * handlers write (workflow toggle/run/actions, scheduled/trigger toggle).
 * Placeholder permission USERS_VIEW.
 */
export function AutomationAuditScreen() {
  const columns = useMemo<AdminColumn<AutomationAuditRow>[]>(
    () => [
      { key: 'created_at', header: S.time, type: 'date', width: 150 },
      { key: 'admin', header: S.admin, type: 'text', width: 160 },
      { key: 'action', header: S.action, type: 'text', width: 220 },
      { key: 'target', header: S.target, type: 'id', width: 160 },
      { key: 'detail', header: S.detail, type: 'longtext', minWidth: 180 },
      { key: 'ip', header: S.ip, type: 'id', width: 140, piiLevel: 'L3' },
    ],
    [],
  )
  const fetcher = useCallback(fetchAutomationAudit, [])
  return (
    <>
      <PageHeader title={S.audit} screenId="A26.12" />
      <DataTable<AutomationAuditRow>
        screenId="A26.12"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <History size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
